// src/components/ContactFooter.jsx
// Contact bar with Mailbox, Slack, and Report Bug links

import React, { useState } from 'react';

const ContactFooter = () => {
    const [showBugModal, setShowBugModal] = useState(false);

    return (
        <>
            {/* Footer Bar */}
            <div style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                padding: '14px 40px',
                background: '#1a1a2e',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '24px',
                flexWrap: 'wrap',
                borderTop: '1px solid #2d2d44',
                zIndex: 1000
            }}>
                <span style={{ fontSize: '13px', fontWeight: '600', color: '#fbbf24' }}>📬 Contact Us</span>
                <a
                    href="mailto:ctps-permissions-security@amazon.com"
                    style={{ fontSize: '13px', color: '#e2e8f0', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px' }}
                >
                    📧 Mailbox
                </a>
                <span style={{ color: '#4a5568' }}>|</span>
                <button
                    onClick={() => setShowBugModal(true)}
                    style={{
                        background: 'none', border: 'none', cursor: 'pointer',
                        fontSize: '13px', color: '#fde68a', display: 'flex', alignItems: 'center', gap: '6px',
                        padding: 0, fontFamily: 'inherit'
                    }}
                >
                    🐛 Report Bug / Suggestion
                </button>
            </div>

            {/* Bug Report Modal */}
            {showBugModal && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    zIndex: 9999
                }} onClick={() => setShowBugModal(false)}>
                    <div style={{
                        background: '#fff', borderRadius: '16px', padding: '40px',
                        maxWidth: '480px', width: '90%', textAlign: 'center',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
                    }} onClick={e => e.stopPropagation()}>
                        {/* Bug icon */}
                        <div style={{ fontSize: '64px', marginBottom: '16px' }}>🐛</div>

                        <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#1a1a2e', marginBottom: '12px' }}>
                            Report a Bug or Suggestion
                        </h2>
                        <p style={{ fontSize: '14px', color: '#555', marginBottom: '24px', lineHeight: '1.6' }}>
                            When you land on the CTI creation page, please select the following so your request reaches us:
                        </p>

                        {/* CTI Info Box */}
                        <div style={{
                            background: '#f0fdf4', border: '2px dashed #86efac', borderRadius: '12px',
                            padding: '20px 24px', textAlign: 'left', marginBottom: '24px'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                                <span style={{ fontSize: '13px', fontWeight: '700', color: '#166534', minWidth: '90px' }}>Category (C)</span>
                                <span style={{ color: '#555' }}>→</span>
                                <span style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a2e' }}>TSE SWAT</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                                <span style={{ fontSize: '13px', fontWeight: '700', color: '#166534', minWidth: '90px' }}>Type (T)</span>
                                <span style={{ color: '#555' }}>→</span>
                                <span style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a2e' }}>Permissions and Access Management</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <span style={{ fontSize: '13px', fontWeight: '700', color: '#166534', minWidth: '90px' }}>Item (I)</span>
                                <span style={{ color: '#555' }}>→</span>
                                <span style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a2e' }}>Access Genie</span>
                            </div>
                        </div>

                        {/* Open CTI Button */}
                        <a
                            href="https://t.corp.amazon.com/create"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                display: 'block', padding: '14px', background: '#fbbf24',
                                color: '#1a1a2e', fontWeight: '700', fontSize: '16px',
                                borderRadius: '10px', textDecoration: 'none',
                                marginBottom: '12px'
                            }}
                        >
                            Next → Open CTI
                        </a>

                        {/* Cancel */}
                        <button
                            onClick={() => setShowBugModal(false)}
                            style={{
                                background: 'none', border: 'none', cursor: 'pointer',
                                fontSize: '14px', color: '#666', padding: '8px',
                                fontFamily: 'inherit'
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default ContactFooter;
